import { $api } from "../AxiosInstance";

export class RentPeriodService {
  static async getRentPeriod() {
    return await $api.get("/api/admin/rentPeriod/all");
  }

  static async getRentPeriodById(id) {
    return await $api.get("/api/admin/rentPeriod", { params: { id } });
  }

  static async getRentPeriodsByProxyType(proxyType) {
    return await $api.get("/api/front/rentPeriod/byType", { params: { proxyType } });
  }

  static async createRentPeriod(params) {
    return await $api.put("/api/admin/rentPeriod", params);
  }

  static async saveRentPeriod(params) {
    return await $api.post("/api/admin/rentPeriod", params);
  }

  static async deleteRentPeriod(id) {
    return await $api.delete("/api/admin/rentPeriod", { params: { id } });
  }
}
